"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustMainPipeV2 = void 0;
const pipeNode_1 = require("./pipeNode");
const LineSegment_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/LineSegment.js"));
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const util_1 = require("../polygon/util");
class AdjustMainPipeV2 {
    adjust(mainLineString, lineStrings, lines, distanceToWall, notSetDistanceToWall) {
        lineStrings.splice(lineStrings.indexOf(mainLineString), 1);
        //以与水流指示器相连的那个多段线作为主要的多段线
        let mainStartNode = this.buildPipeNodesFromPolyline(mainLineString);
        let manager = new Manager();
        //抛弃起始点不在主多段线上的多段线
        for (let lineString of lineStrings) {
            let startNode = this.buildPipeNodesFromPolyline(lineString);
            manager.add(mainStartNode, startNode);
        }
        let adjustedLineSegmentArr = AdjustedLineSegment.buildFromPipeNode(mainStartNode);
        let segments = new Array();
        let angles = new Array();
        for (let line of lines) {
            //line虽然是个数组，但是只有两个点
            let p1 = new Coordinate_js_1.default(line[0].x, line[0].y);
            let p2 = new Coordinate_js_1.default(line[1].x, line[1].y);
            segments.push(new LineSegment_js_1.default(p1, p2));
            angles.push(util_1.Util.computeAngle(p1, p2));
        }
        if (notSetDistanceToWall === false) {
            //对所有线段进行调整
            AdjustManager.traverse(adjustedLineSegmentArr[0], segments, angles, distanceToWall);
        }
        //调整完之后进行对有父子关系的线段进行连接，构建父子节点关系
        adjustedLineSegmentArr[0].initPipeNodes();
        AdjustPipeNodeBuilder.traverse(adjustedLineSegmentArr[0]);
        return adjustedLineSegmentArr[0];
    }
    buildPipeNodesFromPolyline(lineString) {
        let points = lineString.getCoordinates();
        let startNode = new pipeNode_1.PipeNode(new Coordinate_js_1.default(points[0].x, points[0].y), pipeNode_1.PipeNodeType.Main);
        let previousNode = startNode;
        for (let i = 1; i < points.length; i++) {
            let node = new pipeNode_1.PipeNode(new Coordinate_js_1.default(points[i].x, points[i].y), pipeNode_1.PipeNodeType.Main);
            previousNode.addChildNode(node);
            previousNode = node;
        }
        return startNode;
    }
}
exports.AdjustMainPipeV2 = AdjustMainPipeV2;
class Manager {
    constructor() {
        this._success = false;
    }
    add(mainStartNode, childStartNode) {
        this._success = false;
        this.traverse(mainStartNode, childStartNode);
        if (this._success == false) {
            console.error("某条主管线多段线连接失败");
        }
        return this._success;
    }
    traverse(node, childStartNode) {
        for (let child of node._children) {
            let seg = new LineSegment_js_1.default(node._point, child._point);
            if (seg.distance(childStartNode._point) < 1e-3) {
                //判断是否在两个端点处
                if (node._point.distance(childStartNode._point) < 1e-3) { //在当前节点上
                    //node.addChildNode(childStartNode);
                    this.mergeTwoNode(node, childStartNode);
                }
                else if (child._point.distance(childStartNode._point) < 1e-3) { //在子节点上
                    //child.addChildNode(childStartNode);
                    this.mergeTwoNode(child, childStartNode);
                }
                else { //在两点之间
                    node.removeChildNode(child);
                    node.addChildNode(childStartNode);
                    childStartNode.addChildNode(child);
                }
                this._success = true;
                return;
            }
        }
        for (let child of node._children) {
            this.traverse(child, childStartNode);
        }
    }
    mergeTwoNode(node1, node2) {
        if (node2._parent) {
            node2._parent.removeChildNode(node2);
        }
        for (let child of node2._children) {
            node1.addChildNode(child);
        }
    }
}
class AdjustedLineSegment {
    constructor(selfSeg, parent) {
        this._children = [];
        this._pipeNodes = [];
        this._selfSeg = selfSeg;
        this._parent = parent;
        if (parent) {
            parent._children.push(this);
        }
    }
    addChlid(child) {
        this._children.push(child);
        child._parent = this;
    }
    removeChild(child) {
        this._children.splice(this._children.indexOf(child), 1);
        child._parent = undefined;
    }
    //该方法内node_add和该线段一定位于同一直线上
    addPipeNode(node_add, sourceArr) {
        let seg = new LineSegment_js_1.default(this._pipeNodes[0]._point, this._pipeNodes[this._pipeNodes.length - 1]._point);
        let projectionFactor = seg.projectionFactor(node_add._point);
        if (Math.abs(projectionFactor - 0) < 1e-3) {
            this.mergeTwoPipeNode(this._pipeNodes[0], node_add, sourceArr);
        }
        else if (Math.abs(projectionFactor - 1) < 1e-3) {
            this.mergeTwoPipeNode(this._pipeNodes[this._pipeNodes.length - 1], node_add, sourceArr);
        }
        else if (projectionFactor < 0) {
            let parent = this._pipeNodes[0]._parent;
            if (parent === undefined) { //添加到第一段线前面的异常情况
                //但是这段额外的线是否存起来貌似没区别，只要节点信息加上去了就好
                this._parallelSegmentForException = new AdjustedLineSegment(new LineSegment_js_1.default(this._pipeNodes[0]._point, node_add._point), undefined);
                this._parallelSegmentForException._pipeNodes.push(this._pipeNodes[0]);
                this._parallelSegmentForException._pipeNodes.push(node_add);
                this._pipeNodes[0].addChildNode(node_add);
            }
            else {
                parent.removeChildNode(this._pipeNodes[0]);
                parent.addChildNode(node_add);
                node_add.addChildNode(this._pipeNodes[0]);
                this._pipeNodes.splice(0, 0, node_add);
            }
        }
        else if (projectionFactor > 1) {
            this._pipeNodes[this._pipeNodes.length - 1].addChildNode(node_add);
            this._pipeNodes.splice(this._pipeNodes.length, 0, node_add);
        }
        else { //在总的线段中间，接着遍历位于哪一段中间
            let success = false;
            for (let i = 0; i < this._pipeNodes.length - 1; i++) {
                let node1 = this._pipeNodes[i];
                let node2 = this._pipeNodes[i + 1];
                let childSeg = new LineSegment_js_1.default(node1._point, node2._point);
                let projFactor = childSeg.projectionFactor(node_add._point);
                if (Math.abs(projFactor - 0) < 1e-3) {
                    this.mergeTwoPipeNode(node1, node_add, sourceArr);
                    success = true;
                    break;
                }
                else if (Math.abs(projFactor - 1) < 1e-3) {
                    this.mergeTwoPipeNode(node2, node_add, sourceArr);
                    success = true;
                    break;
                }
                else if (projFactor > 0 && projFactor < 1) {
                    node1.removeChildNode(node2);
                    node1.addChildNode(node_add);
                    node_add.addChildNode(node2);
                    this._pipeNodes.splice(i + 1, 0, node_add);
                    success = true;
                    break;
                }
            }
            if (!success) {
                throw Error("节点添加失败");
            }
        }
    }
    initPipeNodes() {
        if (this._pipeNodes.length == 0) {
            this._pipeNodes = [new pipeNode_1.PipeNode(this._selfSeg.p0, pipeNode_1.PipeNodeType.Main), new pipeNode_1.PipeNode(this._selfSeg.p1, pipeNode_1.PipeNodeType.Main)];
            this._pipeNodes[0].addChildNode(this._pipeNodes[1]);
        }
    }
    static buildFromPipeNode(mainStartNode) {
        let segArr = new Array();
        this.traverse(mainStartNode, undefined, segArr);
        return segArr;
    }
    static traverse(node, parent, segArr) {
        for (let child of node._children) {
            let selfSeg = new LineSegment_js_1.default(node._point, child._point);
            let current = new AdjustedLineSegment(selfSeg, parent);
            segArr.push(current);
            this.traverse(child, current, segArr);
        }
    }
    //sourceArr为node_add原本所在的数组，合并节点时需要将数组里的原节点也替换掉
    mergeTwoPipeNode(node, node_add, sourceArr) {
        //node_add的parent一定是为空的
        for (let child of node_add._children) {
            node.addChildNode(child);
        }
        sourceArr[sourceArr.indexOf(node_add)] = node;
    }
}
class AdjustManager {
    static traverse(current, segments, angles, distanceToWall) {
        let p1 = current._selfSeg.p0;
        let p2 = current._selfSeg.p1;
        let seg1 = new LineSegment_js_1.default(p1, p2);
        let angle1 = util_1.Util.computeAngle(p1, p2);
        let segmentMap = new Map();
        for (let j = 0; j < segments.length; j++) {
            let seg2 = segments[j];
            let angle2 = angles[j];
            //只计算夹角小于30°的边
            if (Math.abs(angle1 - angle2) < 15 || Math.abs(angle1 - angle2) > 165) {
                let dis = seg1.distance(seg2);
                segmentMap.set(dis, seg2);
            }
        }
        let segmentPairs = Array.from(segmentMap);
        segmentPairs.sort(function (a, b) { return a[0] - b[0]; });
        let minDis = segmentPairs[0][0];
        //如果偏移距离过大，就不偏移了（一般是由于该段主管线在弧线转角，导致找不到可附着的线段）
        if (minDis < 6000) {
            let disMatchSegments = [segmentPairs[0][1]];
            const adjustTolerance = 110; //该阈值同样和门线段调整阈值大一点点，和外面的同名变量一致
            for (let i = 1; i < segmentPairs.length; i++) {
                if (segmentPairs[i][0] - minDis < adjustTolerance) {
                    disMatchSegments.push(segmentPairs[i][1]);
                }
            }
            //选个满足距离阈值条件的线段里最长的（这里的排序有重复计算，后续可以优化）
            disMatchSegments.sort(function (a, b) { return b.getLength() - a.getLength(); });
            let minDisSeg = disMatchSegments[0];
            let p1_proj = minDisSeg.project(p1);
            let p2_proj = minDisSeg.project(p2);
            //计算从投影点到原来点的向量，设定距离为偏移距离，将线段调整过去
            let offset1 = new Vector2D_js_1.default(p1_proj, p1).normalize().multiply(distanceToWall);
            let offset2 = new Vector2D_js_1.default(p2_proj, p2).normalize().multiply(distanceToWall);
            current._selfSeg = new LineSegment_js_1.default(p1_proj.x + offset1.getX(), p1_proj.y + offset1.getY(), p2_proj.x + offset2.getX(), p2_proj.y + offset2.getY());
        }
        //调整后需要和上一段线重新建立联系
        let parent = current._parent;
        if (parent) {
            //TODO：这里不能直接用直线求交
            let angle1_adjusted = util_1.Util.computeAngle(current._selfSeg.p0, current._selfSeg.p1);
            let angle2_adjusted = util_1.Util.computeAngle(parent._selfSeg.p0, parent._selfSeg.p1);
            let sub_angle = Math.abs(angle1_adjusted - angle2_adjusted);
            let parallel = sub_angle < 1 || sub_angle > 179;
            if (parallel) { //平行的情况
                if (parent._selfSeg.p1.equals2D(current._selfSeg.p0)) {
                    current._selfSeg.p0 = parent._selfSeg.p1;
                }
                else {
                    //如果是平行且不相邻的情况，则需要在中间增加新的线
                    parent.removeChild(current);
                    let middle = new AdjustedLineSegment(new LineSegment_js_1.default(new Coordinate_js_1.default(parent._selfSeg.p1), new Coordinate_js_1.default(current._selfSeg.p0)), parent);
                    middle.addChlid(current);
                }
            }
            else {
                let intersectPoint = parent._selfSeg.lineIntersection(current._selfSeg);
                current._selfSeg.p0 = intersectPoint;
            }
        }
        for (let child of current._children) {
            this.traverse(child, segments, angles, distanceToWall);
        }
    }
}
class AdjustPipeNodeBuilder {
    static traverse(adjustedLineSegment) {
        for (let childSeg of adjustedLineSegment._children) {
            childSeg.initPipeNodes();
            adjustedLineSegment.addPipeNode(childSeg._pipeNodes[0], childSeg._pipeNodes);
            this.traverse(childSeg);
        }
    }
}
